(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);

	// Featured-product thumbnail gallery. Uses event delegation so it works for
	// every featured-product section on the page (both instances) without
	// needing section ids in JS. Clicking a thumbnail brings the matching main
	// media to the front of the (non-Swiper) main list, which shows first-slide
	// only via overflow — the same prepend mechanism used on variant change, so
	// the two stay consistent.
	function fpSetActiveThumb(thumb) {
		var rail = thumb.closest('.fp-media-thumbs');
		if (rail) {
			rail.querySelectorAll('.product__media-subitem').forEach(function (item) {
				item.classList.toggle('swiper-slide-thumb-active', item === thumb);
			});
		}
	}

	document.addEventListener('click', function (event) {
		var thumb = event.target.closest('.fp-media-thumbs .product__media-subitem');
		if (!thumb) return;
		var subId = thumb.getAttribute('data-media-sub-id');
		if (!subId) return;
		var mainSlide = document.querySelector('[data-media-id="' + subId + '"]');
		if (mainSlide && mainSlide.parentElement) {
			mainSlide.parentElement.prepend(mainSlide);
		}
		fpSetActiveThumb(thumb);
		fpSyncRailHeights();
	});

	// Lock each thumbnail rail to the height of its main media (desktop),
	// mirroring the theme's updatethumbnail(): the rail then scrolls its
	// overflow instead of growing the section. Runs for every gallery on
	// the page (both featured-product instances).
	function fpSyncRailHeights() {
		document.querySelectorAll('[data-fp-gallery]').forEach(function (gallery) {
			var main = gallery.querySelector('.fp-media-main');
			var rail = gallery.querySelector('.fp-media-thumbs');
			if (!main || !rail) return;
			if (window.innerWidth > 1100 && main.offsetHeight > 0) {
				rail.style.setProperty('--fp-rail-height', main.offsetHeight + 'px');
			} else if (window.innerWidth <= 1100) {
				rail.style.removeProperty('--fp-rail-height');
			}
		});
	}

	window.addEventListener('load', fpSyncRailHeights);
	window.addEventListener('resize', fpSyncRailHeights);
	document.addEventListener('shopify:section:load', fpSyncRailHeights);
	requestAnimationFrame(fpSyncRailHeights);

	// Highlight the thumbnail for the selected variant. When a variant is
	// chosen, the theme's updateMedia() moves that variant's featured media to
	// the front of the main list; we read that first slide and mark the
	// matching thumbnail active (and scroll it into view in the rail).
	function fpSyncActiveThumbFromMain(gallery) {
		var firstMain = gallery.querySelector(
			'.fp-media-main .swiper-slide[data-media-id]'
		);
		if (!firstMain) return;
		var id = firstMain.getAttribute('data-media-id');
		var thumb = gallery.querySelector(
			'.fp-media-thumbs .product__media-subitem[data-media-sub-id="' + id + '"]'
		);
		if (!thumb) return;
		fpSetActiveThumb(thumb);
		thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
	}

	document.addEventListener('change', function (event) {
		var picker = event.target.closest('variant-radios, variant-selects');
		if (!picker) return;
		var section = picker.closest('[id^="shopify-section-"]');
		if (!section) return;
		var gallery = section.querySelector('[data-fp-gallery]');
		if (!gallery) return;
		// Run after the theme's updateMedia() has reordered the main media.
		requestAnimationFrame(function () {
			fpSyncActiveThumbFromMain(gallery);
			fpSyncRailHeights();
		});
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
			constructor() {
				super();
			}
			hide() {
				super.hide();
				window.pauseAllMedia();
			}
			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			
			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function() {
		function appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
	}
	
		//window.addEventListener('resize', appHeight);
		appHeight();
	});

  } catch(e) { console.error(e); }
})();
})();
